import { service } from '../../../../helpers/http'

export const ActionGetActivityOfferedComponents = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOfferedComponent',
        action: 'getActivityOfferedComponents',
        payload: payload
    })

}

export const ActionPostActivityOfferedComponent = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOfferedComponent',
        action: 'postActivityOfferedComponent',
        payload: payload
    })

}

export const ActionPutActivityOfferedComponent = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOfferedComponent',
        action: 'putActivityOfferedComponent',
        payload: payload
    })

}

export const ActionDeleteActivityOfferedComponent = ({ dispatch }, payload) => {

    return service({
        module: 'domainActivityOfferedComponent',
        action: 'deleteActivityOfferedComponent',
        payload: payload
    })

}
